import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from './Navbar.jsx';
import SuperAdminSidebar from './SuperAdminSidebar.jsx';

const SuperAdminLayout = () => {

  return (
    <div>
      <header>
        <AdminNavbar />
      </header>
      <main>
        <SuperAdminSidebar />
        <Outlet />
      </main>
      <footer>
        {/* Add your admin footer here */}
      </footer>
    </div>
  );
};

export default SuperAdminLayout;
